module.exports = __webpack_public_path__ + "img/current-avatar-border.bcf74593.png";